import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  KidsHubGetPastPerformanceDataResponse,
  KidsHubGetTableParams,
  KidsHubGetTableResponse,
  KidshubGetPastPerformanceDataParams,
  PredictivePerformanceResponse,
  PredictivePerformanceRequestParams,
} from 'model/KidsHub';
import { apiHost } from 'api/apiHost';

export const apiSlice = createApi({
  reducerPath: 'kidshubApi',
  baseQuery: fetchBaseQuery({ baseUrl: apiHost }),
  endpoints: (builder) => ({
    getTableData: builder.query<KidsHubGetTableResponse, KidsHubGetTableParams>({
      query: (body) => ({ url: '/api/funds/kidhub/', method: 'POST', body }),
    }),

    getPastPerformanceData: builder.query<
      KidsHubGetPastPerformanceDataResponse,
      KidshubGetPastPerformanceDataParams
    >({
      query: (body) => ({ url: '/api/funds/performance/past', method: 'POST', body }),
    }),
    getPredictivePerformanceData: builder.query<
      PredictivePerformanceResponse,
      PredictivePerformanceRequestParams
    >({
      query: (body) => ({ url: '/api/funds/performance/predicted', method: 'POST', body }),
    }),
  }),
});

export const {
  useGetTableDataQuery,
  useGetPastPerformanceDataQuery,
  useLazyGetPredictivePerformanceDataQuery,
} = apiSlice;
